/**
 * W-0 — the encrypt-ready persistence seam. EVERY byte a {@link WorkspaceStore} persists is routed through a
 * `PayloadCodec`, so the store always holds an OPAQUE encoded blob (never a live object). The default
 * {@link NoopJsonCodec} is plain JSON — no crypto — but a future WebCrypto impl (client-held key → true E2E)
 * is a drop-in replacement: swap the codec, the store code and blob layout are unchanged.
 */
export interface PayloadCodec {
  /** Serialize an object to the opaque string the store persists. */
  encode(obj: unknown): Promise<string>
  /** Inverse of {@link encode}. */
  decode(s: string): Promise<unknown>
}

/** The default (no-crypto) codec: identity JSON serialization. */
export const NoopJsonCodec: PayloadCodec = {
  encode: (obj) => Promise.resolve(JSON.stringify(obj)),
  decode: (s) => Promise.resolve(JSON.parse(s) as unknown)
}
